import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
//import Loadable from "react-loadable";

import $ from 'jquery';

import css from 'css';
import api from 'api';
import { calculatePoints } from 'partials/modules/Calculator';
import Container from 'partials/Container';
import { Button } from 'partials/formElements';
import { arrayOfObjectsToSCV, msg } from 'helpers';

import ClockIcon from 'images/ClockIcon';
import DownloadIcon from 'images/DownloadIcon';

import {
    setSummaryVisibleValue,
} from 'store';

// split this component into a separate build js chunk and load it only when compoenent is used
/*const DownloadXLSButton = Loadable({
    loader: () => import('partials/DownloadXLSButton'),
    loading() {
        return <div />
    }
});*/

class PointsTracker extends Component {
    async _downloadXLSX() {
        const { programs, yearBorn, additionalPoints } = this.props;
        const summary = calculatePoints({ programs, yearBorn, additionalPoints });

        const response = await api.generateXLSX({ programs, yearBorn, additionalPoints, summary });
        
        if(response && response.data && response.data instanceof Blob) {
            const a = document.createElement('a');
            const url = window.URL.createObjectURL(response.data);
            a.href = url;
            a.download = 'export.xlsx';
            a.click();
            window.URL.revokeObjectURL(url);
        } else {
            alert(msg('xlsxError'));
        }
    }

    /*_prepareDataForXLSXExport() {
        const { programs, yearBorn, additionalPoints } = this.props;

        const summary = calculatePoints({ programs, yearBorn, additionalPoints });

        const grades = programs.map(program => ({
            'Code': program.code || '',
            'Emnenavn': program.emnenavn || '',
            'Fag': program.fag || '',
            'Grade': program.grade || '',
            'Exam grade': program.examGrade || '',
            'Exam 2 grade': program.exam2Grade || ''
        }));

        return {
            sheets: [
                {
                    title: 'Grades',
                    data: grades,
                },
                {
                    title: 'Ekstrapoeng',
                    data: [
                        { 
                            'År født': yearBorn,
                            'Gjennomført førstegangstjenesten': additionalPoints.passedService || '',
                            'Gått et godkjent år på folkehøgskole': additionalPoints.approvedYear || '',
                            '60 studiepoeng fra høyere utdanning': additionalPoints.haCredits60 || '',
                            '30-59 studiepoeng fra høyere utdanning': additionalPoints.haCredits3059 || ''
                        },
                    ]
                },
                {
                    title: 'Summary',
                    data: [
                        { 
                            'Karakterpoeng': summary.forGrades,
                            'Språkpoeng / realfag': summary.forLanguage,
                            'Alderspoeng': summary.forAge,
                            'Tilleggspoeng': summary.forExtras,
                            'Konkurransepoeng': summary.total,
                        },
                    ]
                    
                }
            ],
            fileName: 'export'
        }
    }*/

    _onDoneButtonClick(e) {
        this.props.setSummaryVisibleValue(true);

        $('html, body').animate({
            scrollTop: $("#points-tracker").offset().top - 45
        }, 500);
    }

    render() {
        const { selectedSet, yearBorn, additionalPoints, programs, summaryVisible } = this.props;

        if(!selectedSet) return null;

        const points = calculatePoints({ programs, yearBorn, additionalPoints })
        return (
            <Wrapper id="points-tracker">
                <Container flex wrap>
                    <div className="col">
                        <label>Karakterpoeng</label>
                        <div>{points.forGrades}</div>
                    </div>
                    <div className="col">
                        <label>Språkpoeng / realfag</label>
                        <div>{points.forLanguage}</div>
                    </div>
                    <div className="col">
                        <label>Alderspoeng</label>
                        <div>{points.forAge}</div>
                    </div>
                    <div className="col">
                        <label>Tilleggspoeng</label>
                        <div>{points.forExtras}</div>
                    </div>
                    <div className="col">
                        <label>Konkurransepoeng</label>
                        <div>{points.total}</div>
                    </div>
                    <div className="col download">
                        {!summaryVisible && selectedSet && <Button className="points-button" outline white onClick={this._onDoneButtonClick.bind(this)} ><ClockIcon color="#fff"/>Send og bestill rådgvning</Button>}
                        <Button className="points-button download-button" outline white onClick={this._downloadXLSX.bind(this)}><DownloadIcon color="#fff"/>{msg('btnDownloadXlsx')}</Button>
                    </div>
                </Container>
            </Wrapper>
        );
    }
}

const mapStateToProps = state => ({
    selectedSet: state.calculator.selectedSet,
    yearBorn: state.calculator.yearBorn,
    additionalPoints: state.calculator.additionalPoints,
    programs: state.calculator.programs,
    summaryVisible: state.calculator.summaryVisible,
});

const actions = {
    setSummaryVisibleValue,
}

export default connect(mapStateToProps, actions)(PointsTracker);

/*
|--------------------------------------------------------------------------
|  Styles
|--------------------------------------------------------------------------
*/
const Wrapper = styled.div`
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    z-index: 1001;
    background: ${css.colors.blue};
    .col {
        padding-top: 25px;
        min-height: 170px;
        width: 16.66%;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        transition: border .2s ease-in-out;

        &.download {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-end;
            padding-bottom:25px;
        }

        @media(max-width: 1100px) {
            width:33.33%;
            min-height: 100px;
            &.download {
                width:100%;
                flex-direction:row;
                min-height:auto;
                justify-content: flex-start;
                button {
                    margin-right:25px;
                }
            }
        }

        @media(max-width: 767px) {
            width:100%;
            min-height: auto;
            padding: 15px 0;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
        }

        @media(max-width: 480px) {
            &.download {
                flex-direction:column;
                button {
                    width:100%;
                    margin-right:0;
                    &:first-child {
                        margin-bottom:25px;
                    }
                }
            }
        }

        label {
            margin-bottom: 15px;
            display: block;
            color:#fff;
            @media(max-width: 767px) {
                margin:0;
            }
        }

        div {
            ${css.fonts.SSProSemiBold}
            font-size: 32px;
            color: #fff;
        }

        .download-button {
            border: none;
            background: transparent;
            color: #fff !important;
            white-space: nowrap;
        }

        .points-button {
            @media(min-width: 1100px) {
                padding: 15px 20px;
                height: inherit;
                margin-bottom: 15px;
                text-align: left;
            }

            &:hover {
                .points-icon {
                    g {
                        g {
                            fill: #002857;
                        }
                    }
                }
            }

            .points-icon {
                width: 25px;
                min-width: 25px;
                heigth: 25px;
                margin-right: 10px;
            }
        }
    }
`


// WEBPACK FOOTER //
// ./src/partials/modules/Calculator/PointsTracker.js